export const SET_IPEDS_TAB = 'SET_IPEDS_TAB';
export const GET_INSTITUTIONS_LIST = 'GET_INSTITUTIONS_LIST';
export const GET_INSTITUTIONS_LIST_SUCCESS = 'GET_INSTITUTIONS_LIST_SUCCESS';
export const GET_INSTITUTIONS_LIST_ERROR = 'GET_INSTITUTIONS_LIST_ERROR';